<div class="form-title-container" style="margin-top: 40px;">
  <h3>Capital Social</h3>
</div>

<div class="columns is-multiline" [formGroup]="store.capitalSocialForm">
  <div
    class="column is-12 form-container"
    style="display: flex; align-items: center"
  >
    <p-checkbox
      formControlName="hasSeries"
      binary="true"
      inputId="hasSeries"
    />
    <label for="hasSeries" style="margin-left: 8px; font-weight: 600"
      >¿Tiene serie?</label
    >
  </div>

  @if (store.hasSeries()) {
  <div class="column is-12">
    <div class="series-header">
      <div class="total-series-container">
        <span class="total-series-badge">
          <fa-icon [icon]="faNotes"></fa-icon>
          <span class="badge-label">Capital social total:</span>
          <span class="badge-value">{{ store.formatEs(store.calcTotalSeries()) }}</span>
        </span>
        <span class="total-series-badge">
          <fa-icon [icon]="faNotes"></fa-icon>
          <span class="badge-label">Total acciones:</span>
          <span class="badge-value">{{ store.formatShareCount(store.totalCompanyShares()) }}</span>
        </span>
      </div>
      <a class="button add-button" (click)="store.openFormModal()">Añadir serie</a>
    </div>

    <div class="card">
      <app-clients-table
        [configTable]="store.seriesTableConfig()"
        (openItemEvent)="store.openFormModal($event)"
        (deleteItemEvent)="onDeleteSerie($event)"
      ></app-clients-table>
    </div>

    <div class="socios-summary" style="margin-top: 1rem; margin-bottom: 3rem;">
      <span>Capital social total: <strong>{{ store.formatEs(store.calcTotalSeries()) }} €</strong></span>
      <span style="margin-left: 1.5rem;">Total acciones: <strong>{{ store.formatShareCount(store.totalCompanyShares()) }}</strong></span>
    </div>
  </div>

  } @else {
  <div class="column is-12">
    <div class="series-header">
      <div class="total-series-container center">
        <span class="total-series-badge">
          <fa-icon [icon]="faNotes"></fa-icon>
          <span class="badge-label">Capital social total:</span>
          <span class="badge-value"
            >{{
              store.formatEs(
                (store.capitalSocialForm.get('totalShares')?.value || 0) *
                  (store.capitalSocialForm.get('nominalValue')?.value || 0)
              )
            }}
          </span>
        </span>
        <span class="total-series-badge">
          <fa-icon [icon]="faNotes"></fa-icon>
          <span class="badge-label">Total acciones:</span>
          <span class="badge-value">{{ store.formatShareCount(store.totalCompanyShares()) }}</span>
        </span>
      </div>
    </div>
    <div class="columns is-multiline">
      <div class="column is-3 form-container">
        <span class="label">Número de acciones total</span>
        <p-inputNumber
          [useGrouping]="true"
          locale="es-ES"
          class="search-input"
          formControlName="totalShares"
        />
      </div>
      <div class="column is-3 form-container">
        <span class="label">Valor nominal</span>
        <p-inputNumber
          [useGrouping]="true"
          locale="es-ES"
          mode="decimal"
          [minFractionDigits]="2"
          [maxFractionDigits]="2"
          class="search-input"
          formControlName="nominalValue"
        />
      </div>
      <div class="column is-6 form-container">
        <span class="label">Numeración acciones</span>
        <div class="range-row">
          <span class="range-label">Desde</span>
          <p-inputNumber
            [useGrouping]="true"
            locale="es-ES"
            class="search-input range-input"
            formControlName="sharesNumberFrom"
          />
          <span class="range-label">hasta</span>
          <p-inputNumber
            [useGrouping]="true"
            locale="es-ES"
            class="search-input range-input"
            formControlName="sharesNumberTo"
          />
        </div>
        @if (store.capitalSocialForm.errors?.['rangeInvalid']) {
        <p class="help is-danger" style="margin-top: 6px">
          La numeración no es válida: la númeración debe ir de menos a mayor.
        </p>
        }
        @if (store.capitalSocialForm.errors?.['sharesCountMismatch']) {
        <p class="help is-danger" style="margin-top: 6px">
          El número de acciones total (<strong>{{ store.formatShareCount(store.capitalSocialForm.errors['sharesCountMismatch'].actualCount) }}</strong>)
          no coincide con la numeración indicada, que abarca
          <strong>{{ store.formatShareCount(store.capitalSocialForm.errors['sharesCountMismatch'].expectedCount) }}</strong> acciones.
        </p>
        }
      </div>
    </div>
  </div>
  }
</div>

<div class="modal" [class.is-active]="store.isModalActive()">
  <div class="modal-background" (click)="store.closeModal()"></div>
  <div class="modal-card">
    <form [formGroup]="store.modalForm" (ngSubmit)="saveSerieModal()">
      <header class="modal-card-head">
        @if (store.isCreating()) {
        <p class="modal-card-title">Nueva Serie</p>
        } @else {
        <p class="modal-card-title">Editar Serie</p>
        }
      </header>
      <section class="modal-card-body">
        <div class="field">
          <label class="label">Tipo/Serie</label>
          <input
            class="input"
            formControlName="name"
            placeholder="Ej: SERIE A"
          />
        </div>
        <div class="field">
          <label class="label">Número de acciones total</label>
          <p-inputNumber
            [useGrouping]="true"
            locale="es-ES"
            class="search-input"
            formControlName="totalShares"
          ></p-inputNumber>
        </div>
        <div class="field">
          <label class="label">Valor nominal por acción</label>
          <p-inputNumber
            [useGrouping]="true"
            locale="es-ES"
            mode="decimal"
            [minFractionDigits]="2"
            [maxFractionDigits]="2"
            class="search-input"
            formControlName="nominalValue"
          ></p-inputNumber>
        </div>
        <div class="field">
          <label class="label">Numeración acciones</label>
          <div class="range-row">
            <span class="range-label">De la</span>
            <p-inputNumber
              [useGrouping]="true"
              locale="es-ES"
              class="search-input range-input"
              formControlName="sharesNumberFrom"
            ></p-inputNumber>
            <span class="range-label">a la</span>
            <p-inputNumber
              [useGrouping]="true"
              locale="es-ES"
              class="search-input range-input"
              formControlName="sharesNumberTo"
            ></p-inputNumber>
          </div>
          @if (store.modalForm.errors?.['rangeInvalid']) {
          <p class="help is-danger" style="margin-top: 6px">
            La numeración no es válida: la numeración debe ir de menor a mayor.
          </p>
          }
          @if (store.modalForm.errors?.['sharesCountMismatch']) {
          <p class="help is-danger" style="margin-top: 6px">
            El número de acciones total (<strong>{{ store.formatShareCount(store.modalForm.errors['sharesCountMismatch'].actualCount) }}</strong>)
            no coincide con la numeración indicada, que abarca
            <strong>{{ store.formatShareCount(store.modalForm.errors['sharesCountMismatch'].expectedCount) }}</strong> acciones.
          </p>
          }
        </div>
        <div class="field">
          <label class="label">Capital social de la serie</label>
          <input
            class="search-input no-select"
            pInputText
            [readonly]="true"
            tabindex="-1"
            aria-disabled="true"
            [value]="
              store.formatEs(
                (store.modalForm.get('totalShares')?.value || 0) *
                  (store.modalForm.get('nominalValue')?.value || 0)
              )
            "
          />
        </div>
      </section>
      <footer class="modal-card-foot buttons-container">
        <button
          class="button cancel-button"
          type="button"
          (click)="store.closeModal()"
        >
          Cancelar
        </button>
        <button
          class="button save-button"
          type="submit"
          [disabled]="!store.modalForm.valid"
        >
          Guardar
        </button>
      </footer>
    </form>
  </div>
</div>
